import type {
  CheckQuotaContent,
  CheckQuotaReq,
  ClassSubTypeData,
  LivestreamData,
  LivestreamRequest,
  PlayOrDownloadReq,
  PlayOrDownloadRes,
  VideoData,
  VideoRequest
} from '@/models/interface/videoLibrary';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class VideoLibraryService extends ApiFactory {
  constructor() {
    super('Library');
  }

  fetchClassSubType(): Promise<ApiDataResponse<ClassSubTypeData[]>> {
    return super.get('ClassSubTypes');
  }

  fetchVideoData(params: VideoRequest): Promise<ApiDataResponse<VideoData>> {
    return super.post('Videos', params);
  }

  fetchLiveStreamingData(params: LivestreamRequest): Promise<ApiDataResponse<LivestreamData>> {
    return super.get('LiveStream', params);
  }

  fetchCheckQuota(params: CheckQuotaReq): Promise<ApiDataResponse<CheckQuotaContent>> {
    return super.get('CheckDownloadQuota', params);
  }

  fetchPlayOrDownload(classId: PlayOrDownloadReq): Promise<ApiDataResponse<PlayOrDownloadRes>> {
    return super.post('PlayVideo?classId=' + classId, '');
  }

  fetchPlayOrDownloadHistory(): Promise<ApiDataResponse<string[]>> {
    return super.get('History');
  }
}
